import { render } from "./EditorHelpModal.vue?vue&type=template&id=3cb4f4ac&scoped=true"
import script from "./EditorHelpModal.vue?vue&type=script&lang=js"
export * from "./EditorHelpModal.vue?vue&type=script&lang=js"

import "./EditorHelpModal.vue?vue&type=style&index=0&id=3cb4f4ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb4f4ac"]])

export default __exports__